export default __webpack_public_path__ + "static/media/Freebooter's Boots of the Savage Sun.a341e334.jpg";